import { render, staticRenderFns } from "./advStatisticsPage.vue?vue&type=template&id=3715bb9e&"
import script from "./advStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./advStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports